import React from 'react';

interface LinhaSelecaoProps {
  inputId: string;
  label: string;
  detalhe?: string;
  selecionado: boolean;
  onToggle: () => void;
  desabilitado?: boolean;
  modo?: 'checkbox' | 'radio';
  titulo?: string;
}

/**
 * Item da lista dos seletores de entidade no mobile.
 *
 * Nao reusa `LinhaConjunto`/`LinhaUsina` do desktop de proposito: aquelas sao
 * linhas de tabela virtualizada, posicionadas em absoluto por
 * `@tanstack/react-virtual` e divididas em celulas por coluna. No mobile a
 * lista e vertical e sem colunas — o markup nao sobrevive a transposicao.
 * As regras (filtro, ordenacao, selecao) e que sao reusadas, via hooks.
 */
export default function LinhaSelecao({
  inputId,
  label,
  detalhe,
  selecionado,
  onToggle,
  desabilitado = false,
  modo = 'checkbox',
  titulo,
}: LinhaSelecaoProps) {
  const classes = [
    'windx-seletor-sheet-linha',
    selecionado ? 'is-selecionada' : '',
    desabilitado ? 'is-indisponivel' : '',
  ].filter(Boolean).join(' ');

  return (
    <label htmlFor={inputId} className={classes} title={titulo}>
      <input
        id={inputId}
        type={modo}
        className="form-check-input"
        checked={selecionado}
        onChange={onToggle}
        disabled={desabilitado}
      />
      <span className="windx-seletor-sheet-linha-texto">
        <span className="windx-seletor-sheet-linha-label">{label}</span>
        {detalhe && (
          <span className="windx-seletor-sheet-linha-detalhe">{detalhe}</span>
        )}
      </span>
    </label>
  );
}
